
export const clientVersion = {
    BuildVersionFull: '2.12.0.12',
    BuildDescription: 'No build description provided'
}